module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921054149_T.7a131d4e.jpg";